export const LOAD_ADDRESSES_REQUEST = 'LOAD_ADDRESSES_REQUEST';
export const LOAD_ADDRESSES_SUCCESS = 'LOAD_ADDRESSES_SUCCESS';
export const LOAD_ADDRESSES_FAILURE = 'LOAD_ADDRESSES_FAILURE';

export const SET_NEW_ADDRESS = 'SET_NEW_ADDRESS';
